import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { changePasswordAPI } from '../../redux/slices/ChnagePasswordSlice';
import { toast } from 'react-toastify';
import { errorHandler } from '../../constants/base';

const ChangePasswordForm = () => {
    const [showOldPass, setShowOldPass] = useState(false);
    const [showConfirmPass, setShowConfirmPass] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const dispatch = useDispatch();
    const loading = useSelector(state => state.ChnagePasswordSlice.loading)
    const user = useSelector(state => state.AuthSlice.user)

    const validationSchema = yup.object().shape({
        old_password: yup
            .string()
            .required("Old password is required"),
        password: yup
            .string()
            .matches(
                /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                "Password must be at least 8 characters, include 1 uppercase, 1 number, and 1 special character"
            )
            .required("New password is required"),
        confirm_password: yup
            .string()
            .oneOf([yup.ref('password'), null], "Passwords must match")
            .required("Confirm password is required"),
    });

    const handleSubmit = async (values) => {
        const res = await dispatch(changePasswordAPI(values))
        if (changePasswordAPI.fulfilled(res)) {
            if (res.payload.success || res.payload.status === 200) {
                toast.success("Password is Update Successfully")
            } else {
                errorHandler(res.payload.errors);
            }
        } else if (changePasswordAPI.rejected(res)) {
            errorHandler(res.payload.errors);
        } else {
            toast.error('Sorry, something went wrong!');
        }
    };

    return (
        <Formik
            initialValues={{
                old_password: '',
                password: '',
                confirm_password: '',
                email: user?.email
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ values, handleChange, handleBlur }) => (
                <Form className="sample-setting-box">
                    <h1 className='home-main-heading mb-4'>Change Password</h1>

                    <div className="mb-3 custom-input-box">
                        <Field
                            type={showOldPass ? "text" : "password"}
                            name="old_password"
                            placeholder="Old Password"
                            className="form-control pass-input"
                        />
                        <i
                            className={`fa-solid ${showOldPass ? 'fa-eye-slash' : 'fa-eye'}`}
                            onClick={() => setShowOldPass(!showOldPass)}
                            style={{ cursor: 'pointer' }}
                        ></i>
                        <ErrorMessage name="old_password" component="div" className="error-text" />
                    </div>

                    <div className="mb-3 custom-input-box">
                        <Field
                            type={showPass ? "text" : "password"}
                            name="password"
                            placeholder="Create Password"
                            className="form-control pass-input"
                        />
                        <i
                            className={`fa-solid ${showPass ? 'fa-eye-slash' : 'fa-eye'}`}
                            onClick={() => setShowPass(!showPass)}
                            style={{ cursor: 'pointer' }}
                        ></i>
                        <ErrorMessage name="password" component="div" className="error-text" />
                    </div>

                    <div className="mb-3 custom-input-box">
                        <Field
                            type={showConfirmPass ? "text" : "password"}
                            name="confirm_password"
                            placeholder="Confirm Password"
                            className="form-control pass-input"
                        />
                        <i
                            className={`fa-solid ${showConfirmPass ? 'fa-eye-slash' : 'fa-eye'}`}
                            onClick={() => setShowConfirmPass(!showConfirmPass)}
                            style={{ cursor: 'pointer' }}
                        ></i>
                        <ErrorMessage name="confirm_password" component="div" className="error-text" />
                    </div>

                    <div className="submit-btn-form">
                        <button type="submit" disabled={loading} className="btn btn-primary">
                            {!loading ? "Save" : (
                                <i
                                    style={{ fontSize: "22px" }}
                                    className="fa-solid fa-spinner fa-spin"
                                ></i>
                            )}
                        </button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default ChangePasswordForm;
